// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"52750f9a","165":"7f1d24ea","453":"061b3f0c"}[chunkId] + ".chunk.js";
};